
<template lang="pug">
  .page-account
    h1 Reset Password
    form(@submit.prevent="submit" v-disable-all="busy" v-if="!success")
      .row(v-bind:class="v$.password.$error ? 'has_error' : ''")
        label(for="user_password") New Password
        input(type="password" name="password" id="user_password" v-model="password")
        p.error(v-for="error of v$.password.$errors" :key="error.$uid" v-html="error.$message")
      .row(v-bind:class="v$.password_confirmation.$error ? 'has_error' : ''")
        label(for="user_password_confirmation") Confirm Password
        input(type="password" name="password_confirmation" id="user_password_confirmation" v-model="password_confirmation")
        p.error(v-for="error of v$.password_confirmation.$errors" :key="error.$uid" v-html="error.$message")
      .row.two-cols
        div(v-bind:class="v$.birth_month.$error ? 'has_error' : ''")
          label(for="user_birth_month") Birth Month (MM)
          input(type="number" maxlength="2" name="birth_month" id="user_birth_month" v-model="birth_month")
          p.error(role="status" v-for="error of v$.birth_month.$errors" :key="error.$uid" v-html="error.$message")
        div(v-bind:class="v$.birth_year.$error ? 'has_error' : ''")
          label(for="user_birth_year") Birth Year (YYYY)
          input(type="number" name="birth_year" id="user_birth_year" v-model="birth_year")
          p.error(role="status" v-for="error of v$.birth_year.$errors" :key="error.$uid" v-html="error.$message")
      div.btn(v-if="under18") Sorry, you are not eligible to register at this time.
      .row(v-if="!under18")
        input.btn.btn--primary(type="submit" value="Submit")
    div(v-if="success")
      .success Your account password has been updated successfully.
      .row.link
        <a href="#" @click.prevent="$parent.setPage('signin')">Login here</a>
</template>

<script>
  const Rule2Property = {
    'first name': 'first_name',
    'last name': 'last_name',
    'old_password': 'old_password',
    'zip.code.rule': 'postal_code',
    'unique.email.rule': 'email',
    'password.strength.rule': 'password',
    'password.token.expiration.rule': 'password',
    'password.reuse.rule': 'password'
  };

  import { required, maxLength, minLength, helpers, numeric, minValue, maxValue, sameAs } from '@vuelidate/validators';
  import { mandatory, minSize, maxSize } from '../../helpers/validators.js';
  import { useVuelidate } from '@vuelidate/core';

  export default {
    name: 'Profile',

    components: {
    },

    props: {
    },

    setup() {
      return {
        v$: useVuelidate(null, null, {
          $lazy: true,
          $autoDirty: true
        })
      }
    },

    mounted() {
      const params = new URLSearchParams(window.location.hash.replace(/^.*\?/, ''));
      this.code = params.get('c');
      this.email = params.get('email');
      if (!this.code || this.code.length < 10)
        this.$parent.setPage('profile');
    },

    data() {
      return {
        busy: false,
        success: false,
        password: '',
        password_confirmation: '',
        birth_month: '',
        birth_year: '',
        under18: false,
        vuelidateExternalResults: {
          password: [],
          password_confirmation: [],
          birth_month: [],
          birth_year: [],
        }
      }
    },

    validations () {
      return {
        password: { required, minLength: minLength(8), maxLength: maxLength(128) },
        password_confirmation: { sameAs: sameAs(this.password) },
        birth_month: { required: mandatory('Birth month'), numeric, min: minValue(1), max: maxValue(12) },
        birth_year: { required: mandatory('Birth year'), numeric, min: minValue(1900), max: maxValue(2050) },
      }
    },

    methods: {
      async submit() {
        for (const key in this.vuelidateExternalResults)
          this.vuelidateExternalResults[key] = [];

        const result = await this.v$.$validate();
        if (!result)
          return;

        const birth_date = `${this.birth_year}-${this.birth_month}-01`;

        // Age gate
        if (!this.v$.birth_year.$error && !this.v$.birth_month.$error) {
          const age = (new Date() - new Date(birth_date)) / (1000 * 60 * 60 * 24 * 365);
          if (age < 18) {
            localStorage.setItem('under18', 'yes');
            this.under18 = true;
            return;
          }
        }

        const data = {
          code: this.code,
          email: this.email,
          password: this.password,
          birth_month: this.birth_month,
          birth_year: this.birth_year,
        };

        this.busy = true;
        fetch(
          this.$parent.url + 'password-reset', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          }
        ).then(response => response.json()).then(data => {
          this.busy = false;
          if (data.Errors) {
            const errors = {};
            for (const v of data.Errors) {
              const p = Rule2Property[v.RuleId] || Rule2Property[v.FieldName];
              if (!p)
                continue;
              if (errors[p])
                errors[p].push(v.Message);
              else
                errors[p] = [ v.Message ];
            }
            Object.assign(this.vuelidateExternalResults, errors);
            return;
          }
          if (data.Result == "Success")
            this.success = true;
        }).catch(() => {
        });
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
